import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, CanLoad } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { ModalService } from '~auth/services';
import { AuthService } from '~auth/services';
// import { SignInComponent } from '../components';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private modal: ModalService,
    private authService: AuthService) { }

  isAuthorized() {
    // if (this.authService.isAuthenticated()) return Promise.resolve(true);

    return Promise.resolve(false);
    // return this.authService
    //   .refresh(true)
    //   .switchMap(u => {
    //     if (u) return Observable.of(true);

    //     return this.modal.getModalComponent(SignInComponent)
    //       .then(result => Promise.resolve(this.authService.isAuthenticated()));
    //   })
    //   .catch(e => {
    //     return this.modal.getModalComponent(SignInComponent)
    //       .then(result => Promise.resolve(this.authService.isAuthenticated()));
    //   })
    //   .take(1)
    //   .toPromise();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    return this.isAuthorized();
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    return this.isAuthorized();
  }

  canLoad() {
    return this.isAuthorized();
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/guards/auth.guard.ts